import { Theme, radius, rem, spacing, token } from '@thiememeulenhoff/lit-sdk';
import * as coreToken from '@thiememeulenhoff/tokens/core';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../../helpers';

export const tag = tagName('content-modal');
const theme = new Theme(tag);

export const styles = [
  css`
    :where(dialog) {
      ${theme.props([
        ['background', 'background', token('background-secondary')],
        ['border-radius', 'border-radius', radius('medium')],
      ])};

      min-inline-size: ${rem(740)};

      @media (max-width: ${unsafeCSS(coreToken.BreakpointSmall)}) {
        min-inline-size: 90vw;
      }
    }

    :where(dialog[open]) {
      display: flex;
      flex-direction: column;

      :where(.content-wrapper) {
        overflow-y: auto;
      }
    }

    :where(container) {
      display: flex;
      flex-direction: column;
      gap: ${spacing(150)};
      padding: ${spacing(250)};

      &.has-header {
        gap: 0;
        padding-block-start: 0;
        padding-inline: 0;

        header {
          padding-block-end: ${spacing(150)};
          padding-block-start: ${spacing(250)};
          ${theme.props([['background', 'background', token('background-secondary')]])};
        }

        main,
        header,
        footer {
          padding-inline: ${spacing(250)};
        }
      }
    }

    :where(header) {
      font-weight: bold;
    }

    :where(.loaderBackground) {
      background-color: ${token('background-secondary')};
      opacity: 0.9;
    }

    :where(.loading) {
      display: flex;
      justify-content: center;
    }

    :where(.loading, .loaderBackground) {
      block-size: 100%;
      inline-size: 100%;
      inset-block-start: 0;
      position: absolute;
    }
  `,
];
